import { SAVE_USER } from '../ActionsType';

const user = {};

export default (state = user, action) => {
  switch (action.type) {
    case SAVE_USER:
      return { ...action.user };

    default:
      return state;
  }
};
